export function computeRoiSuvStats(suvArray) {
  const n = suvArray ? suvArray.length : 0;
  if (!n) {
    return {
      ne: true,
      voxelCount: 0,
      suvMax: null,
      suvMean: null,
      suvMin: null,
      suvSD: null,
    };
  }

  let max = -Infinity;
  let min = Infinity;
  let sum = 0;
  let sumSq = 0;
  for (let i = 0; i < n; i++) {
    const v = suvArray[i];
    if (v > max) max = v;
    if (v < min) min = v;
    sum += v;
    sumSq += v * v;
  }
  const mean = sum / n;
  const variance = Math.max(0, sumSq / n - mean * mean);

  return {
    ne: false,
    voxelCount: n,
    suvMax: max,
    suvMin: min,
    suvMean: mean,
    suvSD: Math.sqrt(variance),
  };
}
